import styled from '@emotion/styled';
import { space } from 'folio-common-components';
import { cardStyle } from './card-style';

export const PageCard = styled.div`
  ${cardStyle};
  ${space([16, 48], 'padding-horizontal')};
  ${space([32, 48], 'padding-vertical')};
`;
